import React, { useCallback, useEffect } from 'react';
import { UserActivityCategory, UserActivityTypes } from '@pascal/iframe-service';

import { useStore, useTranslation } from '../../../../../hooks';
import { SideMenuIcons } from '../../../../../enums';
import { T } from '../../../../../constants';

interface SidebarPromoProps {
  onClose: () => void;
}

export const SidebarPromo: React.FC<SidebarPromoProps> = ({ onClose }) => {

  const t = useTranslation();
  const { promoStore, sidebarMenuStore, sidebarNotificationStore, userActivityStore } = useStore();

  useEffect(() => {
    if (promoStore.promoNotificationScheduled) return;
    promoStore.promoNotificationScheduled = true;
    // no cleanup: the announcement is a global toast and must survive tab switches -
    // clearing on unmount would cancel it forever now that it is scheduled only once
    setTimeout(() => {
      sidebarMenuStore.setHasPromotionsNotification(true);
      sidebarNotificationStore.enqueue(t(T.NEW_PROMO_CODE_AVAILABLE), SideMenuIcons.Promo);
    }, 30_000);
  }, []);

  const onClick = useCallback(() => {
    userActivityStore.sendTrackUserActivity({
      category: UserActivityCategory.PromoTools,
      type: UserActivityTypes.PromoCodeSideBarMenuCard
    });
    onClose();
    promoStore.setPromoModalOpen(true);
  }, [onClose]);

  return (
    <div className="promo-code-block" onClick={onClick}>
      <p className="promo-code-text">{t(T.PROMO_CODE)}</p>
      <p className="claim-your-spin-here">{t(T.CLAIM_YOUR_FREE_SPIN_HERE)}</p>
    </div>
  );
};
